import { HTTP } from "../../../http-common";
import { createHelpers } from "vuex-map-fields";
import { Customer } from "../../../models/customer";

import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";

export const { mapFields: mapCustomerFields } = createHelpers({
  getterType: `customer/getField`,
  mutationType: `customer/updateField`,
});

const state = {
  customer: new Customer(),
  dealerCustomers: [],
  message: new httpError(),
};

//getters

const getters = {
  hasCustomer: (state) => state.customer.customerID > 0,
  getField,
  getCurrentCustomer: (state) => state.customer,
  customerData: (state) => state.dealerCustomers,
};

//Mutations
const mutations = {
  setCustomer(state, customer) {
    state.customer = customer;
  },
  setUB(state, UBAccountNo) {
    state.customer.ubAccountNo = UBAccountNo;
  },
  setQantasNo(state, membershipNo) {
    state.customer.qantasMembershipNo = membershipNo;
  },
  setDealerCustomers(state, customers) {
    if (!customers) state.dealerCustomers = null;
    if (customers.length === 0) state.dealerCustomers = [];
    else {
      state.dealerCustomers = [];
      state.dealerCustomers.length = 0;
      customers.forEach(function(cust) {
        state.dealerCustomers.push(cust);
      });
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setAddress(state, addrID) {
    state.customer.addressID = addrID;
  },
  setGroupNo(state, groupNo) {
    state.customer.groupNo = groupNo;
  },
  updateDirector(state) {
    state.customer.companyDetails.directorGivenName = state.customer.firstName;
    state.customer.companyDetails.directorSurname = state.customer.surname;
  },
  updateField,
};

//ACTIONS
const actions = {
  getDealerCustomer(account) {
    return state.dealerCustomers.find((s) => s.ubAccountNo == account);
  },
  addCustomerToUB({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      if (state.customer.ubAccountNo > 0) {
        resolve();
        return;
      }

      var response = HTTP.post("Customer/AddCustomerToUB", state.customer);
      response
        .then((data) => {
          var result = data.data;
          commit("setUB", result.ubAccountNo);
          dispatch(
            "setMessage",
            new httpError({
              message: "updated Customer",
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "unable to create UB " + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  resetCustomer({ commit }) {
    commit("setCustomer", new Customer());
  },
  async getCustomer({ commit, dispatch }, customerID) {
    var response = HTTP.get("Customer/GetCustomer/" + customerID);
    response
      .then(async function(data) {
        var resultData = data.data;
        commit("setCustomer", resultData);
        await dispatch(
          "setMessage",
          new httpError({
            message: "Retrieved OK",
            httpStatus: 200,
          })
        );

        return Promise.resolve(resultData);
      })
      .catch((err) => {
        dispatch(
          "setMessage",
          new httpError({
            message: "Error:" + err,
            httpStatus: 500,
          })
        );
        return Promise.reject(err);
      });
  },
  listCustomers({ commit }, customerType) {
    return new Promise((resolve, reject) => {
      HTTP.get(
        `Customer/GetDealerCustomers/${!customerType ? "Both" : customerType}`
      )
        .then((data) => {
          commit("setDealerCustomers", data.data);
          resolve(data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }, 
  listCustomerDetails({dispatch}) {
    return new Promise((resolve, reject) => {
        HTTP.get(
            `Support/GetCustomerDetailsWithValidPlan`
        )
            .then((data) => {
                resolve(data.data);
            })
            .catch((e) => {
                dispatch(
                    "setMessage",
                    new httpError({
                        message: err.message,
                        httpStatus: 500
                    }),
                    {
                        root: true
                    }
                );
                reject(e);
            });
    });
  },
  addCustomer({ state, commit, rootState, dispatch }, orderType) {
    return new Promise((resolve, reject) => {
      commit("setGroupNo", rootState.orders.dealer.dealer.groupNo);

      var response = HTTP.post("Customer", state.customer);
      response
        .then(function(data) {
          var resultData = data.data;
          commit("setCustomer", resultData);
          dispatch("orders/getContacts", rootState.orders.rows[0].orderID, {
            root: true,
          });
          dispatch(
            "setMessage",
            new httpError({
              message: "Submitted OK",
              httpStatus: 200,
            })
          );
          dispatch(
            "orders/addOrder",
            {
              customerID: state.customer.customerID,
              type: orderType,
            },
            {
              root: true,
            }
          );
          //create order.
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error in Saving",
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateCustomer(
    { state, commit, dispatch, rootState, rootGetters },
    customerID
  ) {
    return new Promise(async (resolve, reject) => {
      if (!rootGetters["orders/isResidential"])
        var company = HTTP.put(
          `order/UpdateCompany/${rootState.orders.rows[0].orderID}`,
          state.customer.companyDetails
        );
      var response = HTTP.put(
        `Customer/UpdateCustomer/${customerID}/${rootState.orders.rows[0].orderID}`,
        state.customer
      );
      Promise.all([company, response]).then((x) => {
        let resultData = x[1].data;
        dispatch("orders/getContacts", rootState.orders.rows[0].orderID, {
          root: true,
        });
        commit("setCustomer", resultData);
        dispatch(
          "setMessage",
          new httpError({
            message: "Updated OK",
            httpStatus: 200,
          })
        );
        if (rootState.orders.rows[0].orderID === 0) {
          dispatch("orders/addOrder", state.customer.customerID, {
            root: true,
          });
          dispatch(
            "setMessage",
            new httpError({
              message: "Updated OK",
              httpStatus: 200,
            })
          );
          resolve(resultData);
        }
      });
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
